import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import {
  nodeDesignsByIdSelector,
  resolveNodeIdsWithConfigReferencesCreate,
} from "@skilitics/nautilus-core-designer-data";

import { getDesignerNodeByIdSelector } from "./contextualSelectors/index.ts";
import { resolveNodesWithVariableReferencesCreate } from "./selectors/index.ts";

const resolveNodesWithVariableReferencesSelector = createSelector(
  [getDesignerNodeByIdSelector, nodeDesignsByIdSelector],
  (getById, designsById) =>
    resolveNodesWithVariableReferencesCreate(resolveNodeIdsWithConfigReferencesCreate(designsById), getById),
);

export const useResolveNodesWithVariableReferences = () => useSelector(resolveNodesWithVariableReferencesSelector);
